<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center py-5">
        <b-col md="12" sm="12">
          <!-- <register-success v-if="confirmed" @reConfirm="markConfirmed"></register-success>
          <confirmation-form v-else-if="created" @onUserConfirmed="markConfirmed"></confirmation-form> -->
          <register-form
            :custom_error="error"
            @onUserCreated="markCreated"
            @onUserConfirmed="markConfirmed"
          ></register-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import RegisterForm from "../../components/auth/register/RegisterForm";
import ConfirmationForm from "../../components/auth/register/ConfimationForm";
import RegisterSuccess from "../../components/auth/register/RegisterSuccess";
import {AUTH_INVITE} from "@/store/action-types";

export default {
  components: {
    RegisterSuccess,
    ConfirmationForm,
    RegisterForm
  },
  name: 'Register',
  data() {
    return {

      customer: null,
      customer_contact: null,
      customer_location: null,

      error: null,

      customer_uuid: null,
      customer_contact_uuid: null,

    }
  },
  methods: {
    markCreated: function() {
      // console.log('markCreated');
      // this.confirmed = false;
      /* this.customer = JSON.parse(JSON.stringify(customer));
      this.customer_contact = JSON.parse(JSON.stringify(customer.customer_contacts[0]));
      this.customer_location = JSON.parse(JSON.stringify(customer.customer_locations[0])); */
      // this.created = true;
      // if(!data.customer || !data.customer_contact || !data.customer_location) {
      //   this.error = 'Missing required information';
      //   return false;
      // }
      // this.customer = data.customer;
      // this.customer_contact = data.customer_contact;
      // this.customer_location = data.customer_location;
      // this.created = true;
      this.$router.push('/confirm-email')
    },
    markConfirmed: function() {
      // console.log('markConfirmed');
      // this.confirmed = true;
      this.$bvToast.toast('You can now log in.', {
        'title': 'Confirmation Successful',
        variant: 'success'
      });
      this.$router.push('/login');
      // if(!this.customer_uuid && !this.customer_contact_uuid) {
      //   let contact = this.customer_contact;
      //   if(!contact) {
      //     return false;
      //   }
      //   delete contact.password;
      //   delete contact.password_confirm;
      //   let user_uuid = (this.$store.getters.getAuthenticatedUUID || null);
      //   if(user_uuid) {
      //     contact.user_id = user_uuid;
      //   }
      //   let customer = this.customer;
      //   customer.customer_contacts = [contact];
      //   customer.customer_locations = [this.customer_location];
      //   alert('TODO: create customer after use creation');
      //   /*CustomerRepository.create(customer).then(function(response) {
      //     console.log(response);
      //   });*/
      // }
    },
    sendInvite: function() {
      this.$store.dispatch(AUTH_INVITE, {email: 'kwittmack@gmail.com'});
    },

  },
  mounted() {
  }
}
</script>
